import { formatToShortDateTwoYearOrNull } from '~/util/date';
import { createQueryDataTable, type PropsOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { RenderPatientNameNameCell } from '~/features/intake/patients/PatientNameColumn';

const EpisodeTotalsDataTable = createQueryDataTable('schedule-report-admitted-episode-totals');
type TableProps = PropsOfQueryDataTable<typeof EpisodeTotalsDataTable>;

const columnDefinitions = EpisodeTotalsDataTable.columns([
	{
		header: 'Patient',
		key: 'patientName',
		sortable: true,
		renderCell: row => <RenderPatientNameNameCell patient={{ patientIdentifier: row.patientCode, patientName: row.patientName }} />
	},
	{
		header: 'Team',
		key: 'patientTeam',
		filterNames: ['team'],
		sortable: true
	},
	{
		header: 'Insurance',
		key: 'primaryInsurance',
		sortable: true
	},
	{
		header: 'Ch. Ep. Pd.',
		key: 'chartNumber',
		sortable: true,
		renderCell: row => `${row.chartNumber} - ${row.episodeNumber} - ${row.periodNumber}`
	},
	{
		header: 'SOC Date',
		key: 'startOfCare',
		sortable: true,
		renderCell: row => formatToShortDateTwoYearOrNull(row.startOfCare, '-')
	},
	{
		header: 'Start Date',
		key: 'startDate',
		sortable: true,
		filterNames: ['startDate', 'startDateFrom', 'startDateTo'],
		renderCell: row => formatToShortDateTwoYearOrNull(row.startDate, '-')
	},
	{
		header: 'SN',
		key: 'sntotal',
		sortable: true,
		width: 'w-[65px]',
		cellAlign: 'center',
		headerAlign: 'center'
	},
	{
		header: 'PT',
		key: 'pttotal',
		sortable: true,
		width: 'w-[65px]',
		cellAlign: 'center',
		headerAlign: 'center'
	},
	{
		header: 'ST',
		key: 'sttotal',
		sortable: true,
		width: 'w-[65px]',
		cellAlign: 'center',
		headerAlign: 'center'
	},
	{
		header: 'OT',
		key: 'ottotal',
		sortable: true,
		width: 'w-[65px]',
		cellAlign: 'center',
		headerAlign: 'center'
	},
	{
		header: 'MSW',
		key: 'mswtotal',
		sortable: true,
		width: 'w-[65px]',
		cellAlign: 'center',
		headerAlign: 'center'
	},
	{
		header: 'HHA',
		key: 'hhatotal',
		sortable: true,
		width: 'w-[65px]',
		cellAlign: 'center',
		headerAlign: 'center'
	},
	{
		header: 'Other',
		key: 'otherTotal',
		sortable: true,
		width: 'w-[65px]',
		cellAlign: 'center',
		headerAlign: 'center'
	},
	{
		header: 'Missed',
		key: 'totalMissed',
		sortable: true,
		width: 'w-[65px]',
		cellAlign: 'center',
		headerAlign: 'center'
	},
	{
		header: 'Made',
		key: 'totalMade',
		sortable: true,
		width: 'w-[65px]',
		cellAlign: 'center',
		headerAlign: 'center'
	},
	{
		header: 'Remaining',
		key: 'totalRemaining',
		sortable: true,
		width: 'w-[65px]',
		cellAlign: 'center',
		headerAlign: 'center'
	},
	{
		header: 'Total',
		key: 'visitTotal',
		filterNames: ['visitTotal', 'visitTotalFrom', 'visitTotalTo'],
		sortable: true,
		width: 'w-[65px]',
		cellAlign: 'center',
		headerAlign: 'center'
	}
]);

export function EpisodeTotalsTable(props: TableProps) {
	return <EpisodeTotalsDataTable.Table columns={columnDefinitions} emptyMessage="No episode totals" {...props} />;
}
